<template>
	<div id="clients_page_wrapper">
		<!-- desktop select view & search & create new btn -->
		<div class="d-flex justify-content-between clients-filter-container">
			<div class="bb-view-filter">
				<b-form-group>
					<b-form-radio-group id="bb_table_view_filter_toggle" v-model="selectedView" :options="tableViews" buttons name="radios-btn-default"></b-form-radio-group>
				</b-form-group>
			</div>
			<div class="d-flex">
				<div class="bb-clients-table-search d-flex align-items-center">
					<i class="flaticon-search"></i>
					<input type="text" :placeholder="selectedView == 'physicalEntities' ? $t('clients.searchInput.physicalPlaceholder') : $t('clients.searchInput.legalPlaceholder')" v-model="searchTerm" />
				</div>
				<button class="bb-btn btn-success btn-lg new-staff-btn" @click="showLawClientFormModal">
					{{ $t("clients.createClientBtn") }}
				</button>
			</div>
		</div>
		<!-- desktop data table -->
		<v-data-table :headers="tableHeaders" :items="itemsToShow" :items-per-page="perPageValue" hide-default-footer class="bb-table clients-table">
			<template v-slot:group.header="{ headers, group }">
				<td class="bb-table-group-header" :colspan="headers.length"></td>
			</template>
			<template v-slot:item="{ item }">
				<tr class="clients-item-row">
					<td class="text-left name-cell" v-if="selectedView == 'physicalEntities'">
						{{ item.fullName }}
					</td>
					<td class="text-left firm-name-cell" v-if="selectedView == 'legalEntities'">
						{{ item.firmName }}
					</td>
					<td class="text-left legal-form-cell" v-if="selectedView == 'legalEntities'">
						{{ $t("clients.table.legalFormMapper." + item.legalForm) }}
					</td>
					<td class="text-left phone-cell">
						{{ item.phone }}
					</td>
					<td class="text-left item-cell">
						{{ item.email }}
					</td>
					<td class="text-left pin-cell" v-if="selectedView == 'physicalEntities'">
						{{ item.personalIdentityNumber }}
					</td>
					<td class="text-left idNum-cell" v-if="selectedView == 'legalEntities'">
						{{ item.identificationNumber }}
					</td>
					<td class="text-left city-cell">
						{{ item.city }}
					</td>
					<td class="text-left taxpayer-number-cell" v-if="selectedView == 'legalEntities'">
						{{ item.taxpayerNumber }}
					</td>
					<!-- edit & delete button -->
					<td class="text-right edit-cell">
						<div class="table-action-buttons">
							<button class="table-action-button" @click="showClient(item)">
								<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user">
									<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
									<circle cx="12" cy="7" r="4"></circle>
								</svg>
							</button>
							<button class="table-action-button" @click="openEditForm(item)">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit">
									<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
									<path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
								</svg>
							</button>
							<button class="table-action-button" @click="deleteClient(item)">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2">
									<polyline points="3 6 5 6 21 6"></polyline>
									<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
									<line x1="10" y1="11" x2="10" y2="17"></line>
									<line x1="14" y1="11" x2="14" y2="17"></line>
								</svg>
							</button>
						</div>
					</td>
				</tr>
			</template>
		</v-data-table>
		<!-- mobile header -->
		<div class="bb-mobile-header">
			<div class="bb-mobile-header-left">
				<button class="mobile-sidebar-btn" @click="openMobileAside()">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu">
						<line x1="3" y1="12" x2="21" y2="12"></line>
						<line x1="3" y1="6" x2="21" y2="6"></line>
						<line x1="3" y1="18" x2="21" y2="18"></line>
					</svg>
				</button>
			</div>
			<h1>{{ $t("clients.title") }}</h1>
			<div class="bb-mobile-header-right">
				<button @click="openMobileClientsFilter">
					<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M18.0642 0H3.93577C1.76559 0 0 1.76559 0 3.93577V18.0643C0 20.2344 1.76559 22 3.93577 22H18.0643C20.2344 22 22 20.2344 22 18.0642V3.93577C22 1.76559 20.2344 0 18.0642 0ZM20.7109 18.0642C20.7109 19.5236 19.5236 20.7109 18.0642 20.7109H3.93577C2.47638 20.7109 1.28906 19.5236 1.28906 18.0642V3.93577C1.28906 2.47638 2.47638 1.28906 3.93577 1.28906H18.0643C19.5236 1.28906 20.7109 2.47638 20.7109 3.93577V18.0642Z" fill="#253342" />
						<path d="M18.5942 4.83262H8.77756C8.50767 4.03104 7.74949 3.4519 6.85806 3.4519C5.96663 3.4519 5.20845 4.03104 4.93856 4.83262H3.40625C3.0503 4.83262 2.76172 5.1212 2.76172 5.47715C2.76172 5.8331 3.0503 6.12168 3.40625 6.12168H4.9386C5.20849 6.92326 5.96667 7.5024 6.8581 7.5024C7.74953 7.5024 8.50772 6.92326 8.7776 6.12168H18.5943C18.9502 6.12168 19.2388 5.8331 19.2388 5.47715C19.2388 5.1212 18.9502 4.83262 18.5942 4.83262ZM6.85806 6.21333C6.45213 6.21333 6.12188 5.88308 6.12188 5.47715C6.12188 5.07122 6.45213 4.74097 6.85806 4.74097C7.26399 4.74097 7.59424 5.07122 7.59424 5.47715C7.59424 5.88308 7.26399 6.21333 6.85806 6.21333Z" fill="#253342" />
						<path d="M18.5942 10.3556H17.0619C16.792 9.55399 16.0338 8.97485 15.1424 8.97485C14.251 8.97485 13.4928 9.55399 13.2229 10.3556H3.40625C3.0503 10.3556 2.76172 10.6441 2.76172 11.0001C2.76172 11.3561 3.0503 11.6446 3.40625 11.6446H13.2229C13.4928 12.4462 14.251 13.0253 15.1424 13.0253C16.0338 13.0253 16.792 12.4462 17.0619 11.6446H18.5943C18.9502 11.6446 19.2388 11.3561 19.2388 11.0001C19.2388 10.6441 18.9502 10.3556 18.5942 10.3556ZM15.1424 11.7363C14.7365 11.7363 14.4063 11.406 14.4063 11.0001C14.4063 10.5942 14.7365 10.2639 15.1424 10.2639C15.5484 10.2639 15.8786 10.5942 15.8786 11.0001C15.8786 11.406 15.5484 11.7363 15.1424 11.7363Z" fill="#253342" />
						<path d="M18.5942 15.8784H11.539C11.2691 15.0768 10.511 14.4977 9.61953 14.4977C8.7281 14.4977 7.96992 15.0768 7.70003 15.8784H3.40625C3.0503 15.8784 2.76172 16.167 2.76172 16.5229C2.76172 16.8789 3.0503 17.1675 3.40625 17.1675H7.70003C7.96992 17.969 8.7281 18.5482 9.61953 18.5482C10.511 18.5482 11.2691 17.969 11.539 17.1675H18.5943C18.9502 17.1675 19.2388 16.8789 19.2388 16.5229C19.2388 16.167 18.9502 15.8784 18.5942 15.8784ZM9.61953 17.2592C9.21361 17.2592 8.88335 16.9289 8.88335 16.523C8.88335 16.117 9.21361 15.7868 9.61953 15.7868C10.0255 15.7868 10.3557 16.117 10.3557 16.5229C10.3557 16.9289 10.0255 17.2592 9.61953 17.2592Z" fill="#253342" />
					</svg>
				</button>
			</div>
		</div>
		<div id="mobile_clients_wrapper">
			<!-- mobile search clients input field -->
			<div class="bb-input-group search-input">
				<i class="fas fa-search"></i>
				<input type="text" v-model="searchTerm" :placeholder="selectedView == 'physicalEntities' ? $t('clients.searchInput.physicalPlaceholder') : $t('clients.searchInput.legalPlaceholder')" />
				<button class="bb-badge badge-rounded" @click="searchTerm = ''" v-if="searchTerm">
					<i class="ki ki-close icon-md"></i>
				</button>
			</div>
			<!-- mobile clients table -->
			<div class="client-list">
				<div class="client-item" v-for="client in itemsToShow" :key="client.id" @click="showMobileActions(client)">
					<div class="d-flex justify-content-start align-items-center">
						<div class="bb-badge badge-sm badge-rounded" style="flex: 0 0 auto"></div>
						<div class="client-details">
							<span v-if="selectedView == 'physicalEntities'">{{ client.fullName }}</span>
							<span v-if="selectedView == 'legalEntities' ">{{ client.firmName }}</span>
							<small>{{ client.email }}</small>
							<small>{{ client.city }}</small>
						</div>
					</div>
					<i class="la la-angle-right"></i>
				</div>
			</div>
			<!-- mobile actions menu -->
			<div id="mobile_actions_container" class="mobile-actions-container" v-show="mobileActionsVisible" v-click-outside="handleMobileActionsOutsideClick">
				<div class="mobile-actions">
					<button class="mobile-action-btn">
						{{ $t("clients.mobileButtons.showProfile") }}
					</button>
					<button class="mobile-action-btn" @click="openEditForm(mobileSelectedClient); hideMobileActions();">
						{{ $t("clients.mobileButtons.editBtn") }}
					</button>
					<button class="mobile-action-btn danger" @click="deleteClient(mobileSelectedClient); hideMobileActions();">
						{{ $t("clients.mobileButtons.deleteBtn") }}
					</button>
				</div>
				<button class="mobile-action-btn" @click="hideMobileActions()">
					{{ $t("clients.mobileButtons.closeBtn") }}
				</button>
			</div>
			<!-- mobile add new client btn -->
			<button class="mobile-new-client-btn" @click="showLawClientFormModal">
				<i class="la la-plus"></i>
			</button>
		</div>
		<!-- pagination -->
		<div class="bb-table-footer clients-table-footer">
			<v-pagination class="bb-pagination" @input="paginatePage" v-model="activePaginationMeta.current_page" :total-visible="5" :length="activePaginationMeta.last_page"></v-pagination>
			<div class="d-flex justufy-content-between align-items-center">
				<BBSelect class="bb-pagination-per-page-select" :options="perPageOptions" v-model="perPageValue" />
				<span class="bb-table-pagination-text">
					{{ $t("clients.table.pagination.show") }}
					{{ activePaginationMeta.from }} - {{ activePaginationMeta.to }}
					{{ $t("clients.table.pagination.of") }}
					{{ activePaginationMeta.total }}
				</span>
			</div>
		</div>
		<LawClientModal @setTableViewToPhysicalEntities="setTableViewToPhysicalEntities()" @setTableViewToLegalEntities="setTableViewToLegalEntities()" ref="lawClientModal" />
		<PhysicalEntityFormModal ref="physicalEntityFormModal" :perPage="this.perPageValue" :pageNumber="this.activePaginationMeta.current_page" />
		<LegalEntityFormModal ref="legalEntityFormModal" :perPage="this.perPageValue" :pageNumber="this.activePaginationMeta.current_page" />
		<MobileClientsFilter :currentFilter="selectedView" @filter-updated="filterUpdated($event)" />
	</div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module';
import { GET_PHYSICAL_ENTITIES } from '@/core/services/store/physical_entities.module';
import { GET_LEGAL_ENTITIES } from '@/core/services/store/legal_entities.module';
// import { SET_ALERT_MESSAGES } from '@/core/services/store/alert.module.js';
import { mapGetters } from 'vuex';
import { EventBus } from '@/core/services/event-bus.js';
import _ from 'lodash'
import BBSelect from '@/view/content/BBForm/BBSelect.vue';
import MobileClientsFilter from '@/view/pages/components/Client/MobileClientsFilter.vue';
import LawClientModal from '@/view/layout/extras/modal/LawClientModal.vue';
import PhysicalEntityFormModal from '@/view/layout/extras/modal/PhysicalEntityFormModal.vue';
import LegalEntityFormModal from '@/view/layout/extras/modal/LegalEntityFormModal.vue';
import lawClientModalMixin from '@/core/mixins/lawClientModalMixin.js';
import physicalEntityFormMixin from '@/core/mixins/physicalEntityFormMixin.js';
import legalEntityFormMixin from '@/core/mixins/legalEntityFormMixin.js';
import mobileAsideMixin from '@/core/mixins/mobileAsideMixin.js';
// import httpService from '@/core/services/http.service.js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
	name: 'Clients',
	components: {
		BBSelect,
		LawClientModal,
		PhysicalEntityFormModal,
		LegalEntityFormModal,
		MobileClientsFilter,
	},
	mixins: [mobileAsideMixin, lawClientModalMixin, physicalEntityFormMixin, legalEntityFormMixin],
	data() {
		return {
			searchTerm: '',
			physicalEntitiesTableHeaders: [
				{
					text: this.$t('clients.table.columns.name'),
					value: 'fullName',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
				{
					text: this.$t('clients.table.columns.phone'),
					value: 'phone',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
				{
					text: this.$t('clients.table.columns.email'),
					value: 'email',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
				{
					text: this.$t('clients.table.columns.personalIdentityNumber'),
					value: 'personalIdentityNumber',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
				{
					text: this.$t('clients.table.columns.city'),
					value: 'city',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
			],
			legalEntitiesTableHeaders: [
				{
					text: this.$t('clients.table.columns.firmName'),
					value: 'firmName',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
				{
					text: this.$t('clients.table.columns.legalForm'),
					value: 'legalForm',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
				{
					text: this.$t('clients.table.columns.phone'),
					value: 'phone',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
				{
					text: this.$t('clients.table.columns.email'),
					value: 'email',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
				{
					text: this.$t('clients.table.columns.identificationNumber'),
					value: 'identificationNumber',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
				{
					text: this.$t('clients.table.columns.city'),
					value: 'city',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
				{
					text: this.$t('clients.table.columns.taxpayerNumber'),
					value: 'taxpayerNumber',
					align: 'left',
					sortable: false,
					cellClass: 'service-cell',
				},
			],
			selectedView: 'physicalEntities',
			tableViews: [
				{
					text: this.$t('clients.tableViews.physicalEntities'),
					value: 'physicalEntities',
				},
				{
					text: this.$t('clients.tableViews.legalEntities'),
					value: 'legalEntities',
				},
			],
			perPageOptions: [
				{ text: '10', value: 10 },
				{ text: '20', value: 20 },
				{ text: '50', value: 50 },
			],
			perPageValue: 10,
			mobileActionsVisible: false,
			mobileSelectedClient: null,
		};
	},
	methods: {
		/**
		 * Sets selected view to legal entities after legal entity is created
		 * @return {void}
		 */
		setTableViewToLegalEntities() {
			this.selectedView = 'legalEntities';
		},

		/**
		 * Sets selected view to physical entities after physical entity is created
		 * @return {void}
		 */
		setTableViewToPhysicalEntities() {
			this.selectedView = 'physicalEntities';
		},

		/**
		 * Handle filter-updated event from mobileClientsFilter
		 * @param {String} filterValue
		 * @return {void}
		 */
		filterUpdated(filterValue) {
			this.selectedView = filterValue;
		},

		/**
		 * Delete the client
		 * @param {Object} client
		 * @return {void}
		 */
		deleteClient(client) {
			let route = '';
			let getter = '';
			if (this.selectedView == 'physicalEntities') {
				route = '/api/b2b/physical-entities/';
				getter = GET_PHYSICAL_ENTITIES;
			}
			if (this.selectedView == 'legalEntities') {
				route = '/api/b2b/legal-entities/';
				getter = GET_LEGAL_ENTITIES;
			}
			EventBus.$emit('deletingClient', {
				client: client,
				route: route,
				getter: getter,
				current_page: this.activePaginationMeta.current_page
			});
		},

		/**
		 * Open edit form modal for appropriate entity type based on parameter entity
		 *
		 * @param {Object} entity
		 * @return {void}
		 */
		openEditForm(entity) {
			this.selectedView == 'physicalEntities' ? this.editPhysicalEntity(entity) : this.editLegalEntity(entity);
		},

		/**
		 * Open mobile clients filter by imitating click on mobile_clients_filter_toggle element
		 * @return {void}
		 */
		openMobileClientsFilter() {
			document.querySelector('#mobile_clients_filter_toggle').click();
			let targetElement = document.querySelector('#mobile_clients_filter');
			disableBodyScroll(targetElement);
		},

		/**
		 * Handle table row click
		 * @param {Object} client
		 * @return {void}
		 */
		showClient(client) {
			this.$router.push({
				name: 'clientProfile',
				params: {
					entity: this.selectedView == 'physicalEntities' ? 'physical-entities' : 'legal-entities',
					id: client.id,
				},
			});
		},

		/**
		 *	Method to call pagination
		 *  @param {integer} pageNumber
		 * 	@return {void}
		 */
		paginatePage(pageNumber) {
			if (this.selectedView == 'physicalEntities') {
				this.$store.dispatch(GET_PHYSICAL_ENTITIES, {
					pageNumber: pageNumber,
					perPage: this.perPageValue,
					search: this.searchTerm
				});
				return;
			}
			this.$store.dispatch(GET_LEGAL_ENTITIES, {
				pageNumber: pageNumber,
				perPage: this.perPageValue,
				search: this.searchTerm
			});
		},

		/**
		 * Show mobile service actions
		 * @param {Object} staffMember
		 * @return {void}
		 */
		showMobileActions(staffMember) {
			this.mobileSelectedClient = staffMember;
			this.mobileActionsVisible = true;
			this.$emit('toggle-overlay');
			let targetElement = document.querySelector('#mobile_actions_container');
			disableBodyScroll(targetElement);
		},

		/**
		 * Hide mobile actions
		 * @return {void}
		 */
		hideMobileActions() {
			this.mobileSelectedClient = null;
			this.mobileActionsVisible = false;
			this.$emit('toggle-overlay');
			let targetElement = document.querySelector('#mobile_actions_container');
			enableBodyScroll(targetElement);
		},

		/**
		 * Handle mobile actions outside click
		 * @param {Object} event
		 * @return {void}
		 */
		handleMobileActionsOutsideClick(event) {
			if (event.target.classList.contains('offcanvas-overlay') && this.mobileActionsVisible) {
				this.hideMobileActions();
			}
		},
	},
	watch: {
		/**
		 * Watch per page value changes and dispatch actions
		 * @param {Number} perPage
		 * @return {void}
		 */
		perPageValue: function () {
			this.$store.dispatch(GET_PHYSICAL_ENTITIES, {
				pageNumber: 1,
				perPage: this.perPageValue,
				search: this.searchTerm
			});
			this.$store.dispatch(GET_LEGAL_ENTITIES, {
				pageNumber: 1,
				perPage: this.perPageValue,
				search: this.searchTerm
			});
		},

		/**
		 * Watch for change on searchTerm and dispatch actions to get query results
		 * @return {void}
		 */
		searchTerm: _.throttle(function() {
			if (this.selectedView == 'physicalEntities') {
				this.$store.dispatch(GET_PHYSICAL_ENTITIES, {
					perPage: this.perPageValue,
					search: this.searchTerm
				});
			}
			if (this.selectedView == 'legalEntities') {
				this.$store.dispatch(GET_LEGAL_ENTITIES, {
					perPage: this.perPageValue,
					search: this.searchTerm
				});
			}
		}, 1000),

		/**
		 * Watch for selected view change and clear searchTerm
		 * @return {void}
		 */
		selectedView: function(){
			this.searchTerm = ''
		},
	},
	mounted() {
		// Dispatch store SET_BREADCRUMB action to set page title
		this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$t('clients.title') }]);
		// Dispatch store GET_PHYSICAL_ENTITIES action to get physical entities from api
		this.$store.dispatch(GET_PHYSICAL_ENTITIES, { pageNumber: 1 });
		// Dispatch store GET_LEGAL_ENTITIES action to get legal entities from api
		this.$store.dispatch(GET_LEGAL_ENTITIES, { pageNumber: 1 });
	},
	computed: {
		...mapGetters(['allClients', 'allPhysicalEntities', 'allLegalEntities', 'physicalEntitiesMeta', 'legalEntitiesMeta']),

		/**
		 * Return array of table items to display based on selected view
		 * @return {Array}
		 */
		itemsToShow() {
			if (this.selectedView == 'physicalEntities') {
				return this.allPhysicalEntities
			}
			if (this.selectedView == 'legalEntities') {
				return this.allLegalEntities
			}
			return [];
		},

		/**
		 * Return array of table headers to display based on selected view
		 * @return {Array}
		 */
		tableHeaders() {
			if (this.selectedView == 'physicalEntities') {
				return this.physicalEntitiesTableHeaders;
			}
			if (this.selectedView == 'legalEntities') {
				return this.legalEntitiesTableHeaders;
			}
			return [];
		},

		/**
		 * Set appropriate pagination meta object depending on selected type of clients
		 * @return {Array}
		 */
		activePaginationMeta() {
			if (this.selectedView == 'physicalEntities') {
				return this.physicalEntitiesMeta;
			}
			if (this.selectedView == 'legalEntities') {
				return this.legalEntitiesMeta;
			}
			return [];
		},
	},
};
</script>

<style lang="scss">
@import '@/assets/sass/bb-styles/pages/clients.scss';
</style>
